import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import '../css/HomeMini.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import Swal from 'sweetalert2';

class HomeMini extends React.Component {
  constructor(props) {
    super(props);

    this.percentage = this.percentage.bind(this)
    // this.handleHelpClick = this.handleHelpClick(this)

  }

  handleHelpClick = () => {
    Swal.fire({
      title: "Mileage in KM/L",
      html:"<p style='font-size: 18px; font-weight: bold; color: #333;'>The concept of Mileage can be illustrated through the example below:</p>" +
      "<ul style='font-size: 16px; color: #444; line-height: 1.5;'>" +
      "<li style='margin-bottom: 10px;'>12/04/2021 6.54pm: Shell Card charged for 30 liters</li>" +
      "<li style='margin-bottom: 10px;'>17/04/2021 7.20pm: Shell Card charged for 15 liters</li>" +
      "<li style='margin-bottom: 10px;'>Distance travelled by Vehicle between two transactions: 250 KMs</li>" +
      // "<li>Shell Card Mileage of the 12/04/2021 Transaction: 8.33 KM/L</li>" +
      "<li>Vehicle Shell Card Mileage: 250/15 = 16.7 KM/L</li>"+
      "</ul>",
      icon: "info",
      confirmButtonText: "OK",
      customClass: {
        title: "popup-title", // CSS class for the popup title
        container: "popup-container", // CSS class for the popup container
      },
    });
  };
  
  percentage(percent, status, description) {
    let percentClass = 'fa font-medium-1 '
    switch (status) {
      case "Increase":


        if(description === 'Average Vehicle Shell Card Mileage (KM/L)')
        {
            percentClass += 'fa-caret-up percentDecrease'
        }
        else if(description === 'HSSE Score')
        {
            percentClass += 'fa-caret-up percentDecrease'
        }
        else
        {
          percentClass += 'fa-caret-up percentIncrease'
        }

        break;

      case "Decrease":

        if(description === 'Average Vehicle Shell Card Mileage (KM/L)')
        {
            percentClass += 'fa-caret-down percentIncrease'
        }
        else if(description === 'HSSE Score')
        {
          percentClass += 'fa-caret-down percentIncrease'
        }
        else
        {
          percentClass += 'fa-caret-down percentDecrease'       
        }

        break;

      
      case "Equal":
        percentClass += 'fa-caret-up percentIncrease'//'percentIncrease'
        break;
      case "N/A":
          percentClass += 'fa-caret-up percentIncrease'//'percentIncrease'
          break;
      case "":
            percentClass += 'fa-caret-up percentIncrease'//'percentIncrease'
            break;
      case 0:
        percentClass += 'fa-caret-up percentIncrease'//'percentIncrease'
        break;
    }

    return (
      <div className="avatar-content">
        <div className="tooltip">
          <i className={percentClass} >&nbsp;{percent}%</i>
          <span class="tooltiptext">increase/decrease from same time period last month</span>
        </div>
      </div>
    )
  }

  render() {
    return (

      <Card className="card text-center">
        <Card.Header className="text-center pt-1">
        </Card.Header>
        {this.props.description == "Average Vehicle Shell Card Mileage (KM/L)" ?
           <a name="locationShowHelp" className='pr-2 pt-2' onClick={this.handleHelpClick}>
          <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
          </a>
          :
          <div className='pt-4'></div>
          }
        <Card.Body className=''>
          <div className={this.props.cssName}>
            <i className={this.props.Icon} />
           
          </div>
      <div style={{zIndex: '0 !important'}}>
          <h4 className="text-bold-700">{this.props.quantityPrice}</h4>
          
            {this.props.percentage != '-1' ?
            
            this.percentage(this.props.percentage, this.props.status, this.props.description)
           
            :
            
            <div></div>

          }
          </div>
          <label className="mb-0 line-ellipsis">{this.props.description}</label>
        </Card.Body>
      </Card>


    );
  }
}

export default HomeMini;